import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw030aApi, PW030AReportRow, PW030AReportParams } from '../../../services/pw030aApi';

export function usePW030AReport() {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<PW030AReportRow[]>([]);
  const [total, setTotal] = useState(0);

  const [startGrade, setStartGrade]         = useState('');
  const [endGrade, setEndGrade]             = useState('');
  const [excludeDeparted, setExcludeDeparted] = useState(true);

  const handleQuery = useCallback(async () => {
    setLoading(true);
    try {
      const params: PW030AReportParams = {
        startGrade:      startGrade      || undefined,
        endGrade:        endGrade        || undefined,
        excludeDeparted: excludeDeparted,
      };
      const res = await pw030aApi.getReport(params);
      setRecords(res.items || []);
      setTotal(res.total || 0);
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : '查詢失敗';
      message.error(errorMessage);
      setRecords([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [startGrade, endGrade, excludeDeparted]);

  return {
    loading,
    records,
    total,
    startGrade, setStartGrade,
    endGrade, setEndGrade,
    excludeDeparted, setExcludeDeparted,
    handleQuery,
  };
}
